// Biểu đồ ĐƯỜNG doanh thu theo tháng (SVG thuần, không cần thư viện).
// props: months:['YYYY-MM'...], values:[...], color, name
function fmtCompact(n) {
  n = Number(n) || 0;
  if (n >= 1e9) return (n / 1e9).toFixed(1).replace('.', ',') + ' tỷ';
  if (n >= 1e6) return (n / 1e6).toFixed(1).replace('.', ',') + ' tr';
  if (n >= 1e3) return (n / 1e3).toFixed(1).replace('.', ',') + ' k';
  return String(n);
}
function monthLabel(m) {
  const [y, mo] = m.split('-');
  return `T${Number(mo)}/${String(y).slice(2)}`;
}

export default function RevenueChart({ months: monthsIn = [], values: valuesIn = [], color = '#5b8cff', name = 'Doanh thu', labels: labelsIn = null }) {
  if (!monthsIn.length) return null;
  // CẮT các tháng CHƯA TỚI ở cuối (giá trị null = tháng tương lai) để biểu đồ không thừa khoảng
  // trống bên phải. Năm cũ đã đủ 12 tháng -> không có đuôi null -> giữ nguyên.
  let lastIdx = -1;
  for (let i = 0; i < monthsIn.length; i++) if (valuesIn[i] != null) lastIdx = i;
  if (lastIdx < 0) return null; // chưa có tháng nào có dữ liệu
  const months = monthsIn.slice(0, lastIdx + 1);
  const values = valuesIn.slice(0, lastIdx + 1);
  const labels = labelsIn ? labelsIn.slice(0, lastIdx + 1) : null;
  // Tháng CHƯA CÓ dữ liệu (vd tháng tương lai của năm hiện tại) = null -> bỏ qua, không kéo về 0.
  const vals = months.map((_, i) => (values[i] == null ? null : Number(values[i]) || 0));
  const nonNull = vals.filter((v) => v != null);
  const max = Math.max(1, ...(nonNull.length ? nonNull : [0]));

  const W = 720, H = 280;
  const padL = 56, padR = 20, padT = 18, padB = 40;
  const plotW = W - padL - padR;
  const plotH = H - padT - padB;
  const n = months.length;

  const xAt = (i) => padL + (n === 1 ? plotW / 2 : (plotW * i) / (n - 1));
  const yAt = (v) => padT + plotH * (1 - v / max);

  const pts = vals.map((v, i) => ({ x: xAt(i), y: v == null ? null : yAt(v), v, i }));
  const linePts = pts.filter((p) => p.v != null); // chỉ các tháng có dữ liệu
  const linePath = linePts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ');
  const areaPath = linePts.length
    ? `M ${linePts[0].x.toFixed(1)} ${(padT + plotH).toFixed(1)} ` +
      linePts.map((p) => `L ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ') +
      ` L ${linePts[linePts.length - 1].x.toFixed(1)} ${(padT + plotH).toFixed(1)} Z`
    : '';

  const gridY = [0, 0.25, 0.5, 0.75, 1].map((f) => ({ y: padT + plotH * (1 - f), val: max * f }));
  const gid = 'ftgrad-' + color.replace(/[^a-z0-9]/gi, '');

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ minWidth: 480, display: 'block' }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.28" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* lưới + nhãn trục Y */}
        {gridY.map((g, i) => (
          <g key={i}>
            <line x1={padL} y1={g.y} x2={W - padR} y2={g.y} stroke="var(--border)" strokeWidth="1" />
            <text x={padL - 8} y={g.y + 4} textAnchor="end" fontSize="10" fill="var(--muted)">
              {fmtCompact(g.val)}
            </text>
          </g>
        ))}

        {/* vùng tô dưới đường + đường */}
        <path d={areaPath} fill={`url(#${gid})`} />
        <path d={linePath} fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />

        {/* nhãn giá trị + nhãn trục X (không hiển thị dấu chấm ở điểm) */}
        {pts.map((p, i) => (
          <g key={i}>
            {p.v > 0 && (
              <text x={p.x} y={p.y - 9} textAnchor="middle" fontSize="10" fontWeight="700" fill="var(--text)">
                {fmtCompact(p.v)}
              </text>
            )}
            <text x={p.x} y={H - padB + 16} textAnchor="middle" fontSize="11" fill="var(--muted)">
              {labels ? labels[i] : monthLabel(months[i])}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
}
